import axios from 'axios';

// API Endpoints
const GEOLOCATION_API = 'https://validationapi.thetechmenders.com/api/GeoLocation/GetGeoLocation';
const LEAD_API = 'https://leadapi.crmbytes.com/api/Lead/AddLead';

/**
 * Fetch user's geolocation data
 * @returns {Promise<Object>} Geolocation data
 */
export const fetchGeolocation = async () => {
  try {
    const response = await axios.get(GEOLOCATION_API, {
      headers: {
        'accept': 'text/plain'
      }
    });
    return response.data;
  } catch (error) {
    console.error('Geolocation API error:', error);
    return null;
  }
};

/**
 * Submit lead data to CRM
 * @param {Object} leadData - Lead information
 * @returns {Promise<Object>} API response
 */
export const submitLead = async (leadData) => {
  try {
    const response = await axios.post(LEAD_API, leadData, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return {
      success: true,
      data: response.data,
      statusCode: response.status
    };
  } catch (error) {
    // Handle error responses
    if (error.response) {
      return {
        success: false,
        data: error.response.data,
        statusCode: error.response.status,
        message: error.response.data?.errorMessage || error.response.data?.message || 'An error occurred'
      };
    }
    
    // Network or other errors
    return {
      success: false,
      statusCode: 500,
      message: 'Network error. Please try again.'
    };
  }
};

/**
 * Extract country code from dial code string
 * @param {string} dialCode - Dial code (e.g., '+1', '+44')
 * @returns {number} Numeric country code
 */
export const extractCountryCode = (dialCode) => {
  return parseInt(dialCode.replace('+', ''), 10);
};

/**
 * Get country abbreviation from dial code
 * @param {string} dialCode - Dial code
 * @returns {string} Country code (e.g., 'US', 'UK')
 */
export const getCountryFromDialCode = (dialCode) => {
  const countryMap = {
    '+1': 'US',
    '+44': 'UK',
    '+91': 'IN',
    '+86': 'CN',
    '+49': 'DE',
    '+33': 'FR',
    '+81': 'JP',
    '+61': 'AU',
    '+92': 'PK',
    '+31': 'NL',
    '+34': 'ES',
    '+39': 'IT',
    '+7': 'RU',
    '+55': 'BR',
    '+82': 'KR',
    '+52': 'MX',
    '+27': 'ZA',
    '+20': 'EG',
    '+966': 'SA',
    '+971': 'AE'
  };
  
  return countryMap[dialCode] || 'US';
};

/**
 * Prepare lead payload for API submission
 * @param {Object} formData - Form data
 * @param {Object} geoData - Geolocation data
 * @returns {Object} Formatted payload
 */
export const prepareLeadPayload = (formData, geoData) => {
  const countryCode = extractCountryCode(formData.country_code);
  const country = getCountryFromDialCode(formData.country_code);
  
  // Clean phone number - remove all non-numeric characters
  const cleanPhoneNumber = formData.contact_number.replace(/\D/g, '');
  
  const payload = {
    name: formData.full_name,
    email: formData.email,
    countryDialCode: countryCode,
    country: country,
    phoneNumber: cleanPhoneNumber,
    ipAddress: geoData?.data?.ipAddress || '',
    description: formData.message,
    pageUrl: window.location.href,
    city: geoData?.data?.cityName || '',
    state: geoData?.data?.regionName || '',
    geoLocation: geoData ? JSON.stringify(geoData) : '',
    packageTitle: '',
    packageAmount: 0
  };
  
  return payload;
};
